import { Check } from "lucide-react";
import { IMAGES, CONTACT } from "../../content/site";
import { SectionHead } from "./SectionHead";
import { Reveal, ParallaxImage } from "./motion";
import { Leaf } from "./Leaf";
import { Greeting } from "./Greeting";

const VALUES = ["Zuverlässig und gut erreichbar", "Sorgfältige Arbeit bis ins Detail", "Klare Absprachen vorab", "Ordentlich hinterlassene Flächen"];

export const About = () => (
  <section id="ueber" data-testid="about-section" className="relative overflow-hidden bg-[#F3EFE6] py-24 md:py-36">
    <Leaf className="bottom-20 right-[8%] h-20 w-14" color="#1E5631" rotate={-35} drift={60} />
    <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-14 px-5 sm:px-8 lg:grid-cols-12 lg:gap-20">
      <div className="relative lg:col-span-5">
        <ParallaxImage src={IMAGES.jonas} alt="Jonas Feierstein von GRÜNWIRBEL im Garten" testId="about-image" strength={20} overscan={5} imgClassName="object-cover object-top" className="aspect-[4/5] rounded-t-[160px] rounded-b-[28px]" />
        <Reveal delay={0.2} className="absolute -bottom-6 left-6 right-6 rounded-2xl bg-[#FBF9F4] p-5 shadow-[0_20px_50px_-20px_rgba(13,47,24,.35)] sm:left-auto sm:right-[-24px] sm:w-64">
          <p className="text-xs uppercase tracking-[0.2em] text-[#8C6D53]">Ihr Ansprechpartner</p>
          <p data-testid="about-owner-name" className="mt-1 font-display text-2xl text-[#1B281E]">{CONTACT.owner}</p>
        </Reveal>
      </div>
      <div className="lg:col-span-7">
        <SectionHead eyebrow="Über GRÜNWIRBEL" lines={["Persönlich.", "Sorgfältig. Draußen."]} />
        <Reveal delay={0.1}>
          <p className="mt-8 max-w-xl text-base leading-relaxed text-[#4B5B4E] md:text-lg">
            Hinter GRÜNWIRBEL steht {CONTACT.owner}. Wir pflegen Gärten so, als wären es unsere eigenen: mit Ruhe, einem Blick fürs Detail und ehrlichen Absprachen.
          </p>
        </Reveal>
        <Greeting />
        <ul className="mt-10 grid gap-3 sm:grid-cols-2">
          {VALUES.map((v, i) => (
            <Reveal key={v} as="li" delay={0.1 + i * 0.08} className="flex items-center gap-3 rounded-2xl border border-[#E2DDD0] bg-[#FBF9F4] px-5 py-4 text-[#1B281E]">
              <span className="grid h-7 w-7 shrink-0 place-items-center rounded-full bg-[#1E5631] text-[#FBF9F4]"><Check className="h-4 w-4" /></span>
              {v}
            </Reveal>
          ))}
        </ul>
      </div>
    </div>
  </section>
);
